const ModernTravelHeader = () => {
  return (
    <div className="text-center max-w-4xl mx-auto px-4">
      <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-[#1a2b49] tracking-tight">
        Built for modern travel businesses
      </h2>
      <p className="text-gray-500 font-normal mt-4 text-[15px]">
        Explore how Trrip adapts to your specific business model.
      </p>
    </div>
  );
};

export default ModernTravelHeader;
